import React from 'react';

import { useIsMobileBreakpoint } from 'hooks/use-media-query';

import { NeedHelp } from './need-help';
import { NeedHelpLarge } from './need-help-large';

const OrderIssues: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const isMobile = useIsMobileBreakpoint();

  return isMobile ? <NeedHelp>{children}</NeedHelp> : <NeedHelpLarge>{children}</NeedHelpLarge>;
};
export default OrderIssues;
